// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#graphBlock {
  margin-top: 10px;
}

.raJobProfile {
  float: left;
  width: 20%;
}

.modLink {
  float: right;
  text-align: right;
  width: 80%;
}

h2 span, h3 span, h5 span {
  background-color: #EDF2F5;
  display: inline-block;
  width: 235px;
}

h2 span, h3 span {
  line-height: 17px;
}

h2.reportTitle, h3.reportTitle {
  margin-top: 15px;
}

h2.reportTitle span {
  width: 40px;
}

h3.reportTitle span {
  width: 345px;
}

h4 span {
  background-color: #EDF2F5;
  display: inline-block;
  width: 155px;
  line-height: 12px;
}

h5 span {
  margin-top: 5px;
}

h4.innerTitleH4 span {
  width: 25px;
}

h4.traitsTitle {
  margin: 19px 0;
  padding: 0;
}

div p span {
  background-color: #EDF2F5;
  margin-bottom: 5px;
  line-height: 12px;
}

div#traitSummary,
div#predictableBehavior,
div#predictableBehavior div,
div#portrait,
div#portraitSat,
div#prb,
div.instructions,
div.legend {
  background-color: transparent;
  line-height: 14px;
}

div#predictableBehavior div.reportMiniGraphHeader {
  background-color: white;
}

#portraitSat h4 {
  font-size: 11px;
  width: 100%;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
}

div#portrait h4 span, div#portraitSat h4 span {
  background-color: #EDF2F5;
  width: 100px;
  line-height: 12px;
}

ul li div,
h2.talentH2 span {
  width: 120px;
}

ul li div.portraitList {
  width: 240px;
}

ul li:first-child div:not(.portraitList),
ul.satelliteUl li:nth-child(4) div,
ul.ditUl li:last-child div {
  width: 200px;
}

ul.satelliteUl li:last-child div,
ul.ditUl li div {
  width: 300px;
}

ul.ditUl li:nth-child(2) div,
ul.ditUl li:nth-child(5) div {
  width: 330px;
}

ul.ditUl li:nth-child(3) div {
  width: 400px;
}

ul.raUl li:last-child {
  display: none;
}

ul.plainList {
  margin-top: 5px;
}

.h4sep {
  margin-top: 0;
  margin-bottom: 10px;
}

.talentH2 {
  margin: 12px 0;
}

.m0 {
  margin: 0 !important;
}

.emFirstLine {
  max-width: 900px;
  margin-top: 7px;
}

.emSecLine {
  width: 170px;
  margin-bottom: 7px;
}

p span {
  display: inline-block;
  width: 100%;
}

p span:not(.fw):last-child {
  width: 33%;
}

b {
  background-color: #EDF2F5;
  display: inline-block;
  width: 90px;
  line-height: 12px;
}

svg {
  display: block;
}

.fakeLink {
  text-align: right;
}

.fakeLink span {
  background-color: #558cca;
  opacity: 0.5;
}

.fullWidth span {
  width: 100% !important;
}

.DITInteractionTitleWithImage {
  margin-bottom: 10px;
}

.DITInteractionTitleWithImage tr td.DITInteractionTitleContainer {
  padding-top: 5px;
}

.DITInteractionTitleWithImage tr td.DITInteractionTitleContainer span {
  background-color: #EDF2F5;
  display: inline-block;
  width: 120px;
  margin-left: 5px;
  line-height: 13px;
}

.caret {
  margin: 20px 0 0 5px;
}

.mt8 {
  margin-top: 8px !important;
}

.bTAptitudes {
  padding: 0 0 0.35em 0;
  background-color: #EDF2F5;
  display: inline-block;
  width: 120px;
  font-size: 16px;
}

.paddingL9 {
  padding-right: 0.9em;
}

.alignCenter {
  text-align: center;
}

::ng-deep .alignCenter svg {
  opacity: 0.5;
}

.talentContainer {
  width: 100%;
}

.legend {
  padding-top: 1em;
  margin-bottom: 35px;
}

.legend span:first-child,
.legend span:nth-child(3) {
  background-color: #b8b8b8;
  display: inline-block;
  width: 100px;
  height: 12px;
}

.orange {
  background: #5BC8AC;
  display: inline-block;
  height: 12px;
  width: 30px;
}

.blue {
  background: #b7d0ed;
  display: inline-block;
  height: 12px;
  width: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/analysis/right-matches/components/web/right-matches-report-job-iac/right-matches-report-job-iac.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEA;EACI,WAAA;EACA,UAAA;AACJ;;AAEA;EACI,YAAA;EACA,iBAAA;EACA,UAAA;AACJ;;AAGA;EACI,yBAAA;EACA,qBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,cAAA;EACA,UAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,kBAAA;EACA,iBAAA;AAAJ;;AAGA;;;;;;;;EAQI,6BAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,uBAAA;AAAJ;;AAGA;EACI,eAAA;EACA,WAAA;EACA,6BAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,YAAA;EACA,iBAAA;AAAJ;;AAGA;;EAEI,YAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;;;EAGI,YAAA;AAAJ;;AAGA;;EAEI,YAAA;AAAJ;;AAGA;;EAEI,YAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACI,eAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI,oBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,YAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,WAAA;AAAJ;;AAGA;EACI,UAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,sBAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,oBAAA;AAAJ;;AAGA;EACI,0BAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;AAAJ;;AAGA;EACI,oBAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,mBAAA;AAAJ;;AAGA;;EAEI,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;AAAJ","sourcesContent":["#graphBlock {\n    margin-top: 10px;\n}\n\n.raJobProfile {\n    float: left;\n    width: 20%;\n}\n\n.modLink {\n    float: right;\n    text-align: right;\n    width: 80%;\n}\n\n\nh2 span, h3 span, h5 span {\n    background-color: #EDF2F5;\n    display: inline-block;\n    width: 235px;\n}\n\nh2 span, h3 span {\n    line-height: 17px;\n}\n\nh2.reportTitle, h3.reportTitle {\n    margin-top: 15px;\n}\n\nh2.reportTitle span {\n    width: 40px;\n}\n\nh3.reportTitle span {\n    width: 345px;\n}\n\nh4 span {\n    background-color: #EDF2F5;\n    display: inline-block;\n    width: 155px;\n    line-height: 12px;\n}\n\nh5 span {\n    margin-top: 5px;\n}\n\nh4.innerTitleH4 span {\n    width: 25px;\n}\n\nh4.traitsTitle {\n    margin: 19px 0;\n    padding: 0;\n}\n\ndiv p span {\n    background-color: #EDF2F5;\n    margin-bottom: 5px;\n    line-height: 12px;\n}\n\ndiv#traitSummary,\ndiv#predictableBehavior,\ndiv#predictableBehavior div,\ndiv#portrait,\ndiv#portraitSat,\ndiv#prb,\ndiv.instructions,\ndiv.legend {\n    background-color: transparent;\n    line-height: 14px;\n}\n\ndiv#predictableBehavior div.reportMiniGraphHeader {\n    background-color: white;\n}\n\n#portraitSat h4 {\n    font-size: 11px;\n    width: 100%;\n    border-bottom: 1px solid #ccc;\n    margin-bottom: 10px;\n}\n\ndiv#portrait h4 span, div#portraitSat h4 span {\n    background-color: #EDF2F5;\n    width: 100px;\n    line-height: 12px;\n}\n\nul li div,\nh2.talentH2 span {\n    width: 120px;\n}\n\nul li div.portraitList {\n    width: 240px;\n}\n\nul li:first-child div:not(.portraitList),\nul.satelliteUl li:nth-child(4) div,\nul.ditUl li:last-child div {\n    width: 200px;\n}\n\nul.satelliteUl li:last-child div,\nul.ditUl li div {\n    width: 300px;\n}\n\nul.ditUl li:nth-child(2) div,\nul.ditUl li:nth-child(5) div {\n    width: 330px;\n}\n\nul.ditUl li:nth-child(3) div {\n    width: 400px;\n}\n\nul.raUl li:last-child {\n    display: none;\n}\n\nul.plainList {\n    margin-top: 5px;\n}\n\n.h4sep {\n    margin-top: 0;\n    margin-bottom: 10px;\n}\n\n.talentH2 {\n    margin: 12px 0;\n}\n\n.m0 {\n    margin: 0 !important;\n}\n\n.emFirstLine {\n    max-width: 900px;\n    margin-top: 7px;\n}\n\n.emSecLine {\n    width: 170px;\n    margin-bottom: 7px;\n}\n\np span {\n    display: inline-block;\n    width: 100%;\n}\n\np span:not(.fw):last-child {\n    width: 33%;\n}\n\nb {\n    background-color: #EDF2F5;\n    display: inline-block;\n    width: 90px;\n    line-height: 12px;\n}\n\nsvg {\n    display: block;\n}\n\n.fakeLink {\n    text-align: right;\n}\n\n.fakeLink span {\n    background-color: #558cca;\n    opacity: 0.5;\n}\n\n.fullWidth span {\n    width: 100% !important;\n}\n\n.DITInteractionTitleWithImage {\n    margin-bottom: 10px;\n}\n\n.DITInteractionTitleWithImage tr td.DITInteractionTitleContainer {\n    padding-top: 5px;\n}\n\n.DITInteractionTitleWithImage tr td.DITInteractionTitleContainer span {\n    background-color: #EDF2F5;\n    display: inline-block;\n    width: 120px;\n    margin-left: 5px;\n    line-height: 13px;\n}\n\n.caret {\n    margin: 20px 0 0 5px;\n}\n\n.mt8 {\n    margin-top: 8px !important;\n}\n\n.bTAptitudes {\n    padding: 0 0 0.35em 0;\n    background-color: #EDF2F5;\n    display: inline-block;\n    width: 120px;\n    font-size: 16px;\n}\n\n.paddingL9 {\n    padding-right: 0.9em;\n}\n\n.alignCenter {\n    text-align: center;\n}\n\n::ng-deep .alignCenter svg {\n    opacity: 0.5;\n}\n\n.talentContainer {\n    width: 100%;\n}\n\n.legend {\n    padding-top: 1em;\n    margin-bottom: 35px;\n}\n\n.legend span:first-child,\n.legend span:nth-child(3) {\n    background-color: #b8b8b8;\n    display: inline-block;\n    width: 100px;\n    height: 12px;\n}\n\n.orange {\n    background: #5BC8AC;\n    display: inline-block;\n    height: 12px;\n    width: 30px;\n}\n\n.blue {\n    background: #b7d0ed;\n    display: inline-block;\n    height: 12px;\n    width: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
